import { GetDefaultServiceAppointmentData } from './defaultServiceAppointmentData';

export default {
    /**
     * Toggles service appointment edit modal open status.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_APPOINTMENT_EDIT_MODAL (state, data) {
        state.editAppointmentModal.isOpen = data.open;
        state.editAppointmentModal.editingId = data.id;
        state.editAppointmentModal.ticket = data.ticket;

        if (data.open === true) {
            return;
        }

        state.editAppointmentModal.autocomplete.projectsSearchTerm = '';
        state.editAppointmentModal.autocomplete.ordersSearchTerm = '';
        state.editAppointmentModal.autocomplete.projects.splice(0,
            state.editAppointmentModal.autocomplete.projects.length);
        state.editAppointmentModal.autocomplete.orders.splice(0,
            state.editAppointmentModal.autocomplete.orders.length);
        state.editAppointmentModal.autocomplete.types.splice(0,
            state.editAppointmentModal.autocomplete.types.length);
        state.editAppointmentModal.autocomplete.technicians.splice(0,
            state.editAppointmentModal.autocomplete.technicians.length);
        state.editAppointmentModal.autocomplete.expectedDurations.splice(0,
            state.editAppointmentModal.autocomplete.expectedDurations.length);
        state.editAppointmentModal.autocomplete.statuses.splice(0,
            state.editAppointmentModal.autocomplete.statuses.length);
        state.editAppointmentModal.errors = {};
        state.editAppointmentModal.newlyUploadedFiles.splice(0, state.editAppointmentModal.newlyUploadedFiles.length);

        state.editAppointmentModal.data = GetDefaultServiceAppointmentData();
    },

    /**
     * Sets service appointment edit modal projects autocomplete list.
     *
     * @param state State object
     * @param projects Projects list
     */
    SET_APPOINTMENT_EDIT_MODAL_PROJECTS (state, projects) {
        state.editAppointmentModal.autocomplete.projects.splice(0,
            state.editAppointmentModal.autocomplete.projects.length, ...projects);
    },

    /**
     * Sets service appointment edit modal orders autocomplete list.
     *
     * @param state State object
     * @param orders Orders list
     */
    SET_APPOINTMENT_EDIT_MODAL_ORDERS (state, orders) {
        state.editAppointmentModal.autocomplete.orders.splice(0,
            state.editAppointmentModal.autocomplete.orders.length, ...orders);
    },

    /**
     * Sets service appointment edit modal data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_APPOINTMENT_EDIT_MODAL_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            state.editAppointmentModal.data[keys[i]] = data[keys[i]];
        }
    },

    /**
     * Sets service appointment creation information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_APPOINTMENT_CREATION_INFO (state, data) {
        state.editAppointmentModal.autocomplete.types.splice(0, state.editAppointmentModal.autocomplete.types.length,
            ...data.types);
        state.editAppointmentModal.autocomplete.technicians.splice(0,
            state.editAppointmentModal.autocomplete.technicians.length, ...data.technicians);
        state.editAppointmentModal.autocomplete.expectedDurations.splice(0,
            state.editAppointmentModal.autocomplete.expectedDurations.length, ...data.expected_durations);
        state.editAppointmentModal.autocomplete.statuses.splice(0,
            state.editAppointmentModal.autocomplete.statuses.length, ...data.statuses);
        state.editAppointmentModal.autocomplete.responsiblePartyTypes.splice(0,
            state.editAppointmentModal.autocomplete.responsiblePartyTypes.length, ...data.responsible_party_types);
    },

    /**
     * Sets service appointment edit modal validation errors.
     *
     * @param state State object
     * @param data Errors
     */
    SET_APPOINTMENT_EDIT_MODAL_ERRORS (state, data) {
        state.editAppointmentModal.errors = data;
    },

    /**
     * Toggles service appointment list refresh.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_LIST_REFRESH (state, data) {
        state.appointmentList.refreshList = data;
    },

    /**
     * Sets projects autocomplete search term.
     *
     * @param state State object
     * @param term Search term
     */
    SET_PROJECTS_SEARCH_TERM (state, term) {
        state.editAppointmentModal.autocomplete.projectsSearchTerm = term;
    },

    /**
     * Sets orders autocomplete search term.
     *
     * @param state State object
     * @param term Search term
     */
    SET_ORDERS_SEARCH_TERM (state, term) {
        state.editAppointmentModal.autocomplete.ordersSearchTerm = term;
    },

    /**
     * Adds new attachment
     *
     * @param state State object
     * @param data Data object
     */
    APPEND_APPOINTMENT_NEW_ATTACHMENT (state, data) {
        state.editAppointmentModal.data.newAttachments.push(data.fileObject);
        state.editAppointmentModal.newlyUploadedFiles.push(data.fileName);
    },

    /**
     * Voids attachment
     *
     * @param state State object
     * @param id attachment id
     */
    VOID_APPOINTMENT_ATTACHMENT (state, id) {
        state.editAppointmentModal.data.attachments.forEach(attachment => {
            if (attachment.id === id) {
                attachment.is_voided = true;
            }
        });
    },

    /**
     * Sets service appointment filters information.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FILTERS_INFO (state, data) {
        state.appointmentList.filterData.types.splice(0, state.appointmentList.filterData.types.length, ...data.types);
        state.appointmentList.filterData.statuses.splice(0, state.appointmentList.filterData.statuses.length,
            ...data.statuses);
        state.appointmentList.filterData.assignees.splice(0, state.appointmentList.filterData.assignees.length,
            ...data.assignees);
        state.appointmentList.filterData.report_statuses.splice(0,
            state.appointmentList.filterData.report_statuses.length, ...data.report_statuses);
    },

    /**
     * Sets service appointment list filters data.
     *
     * @param state State object
     * @param data Data object
     */
    SET_FILTERS_DATA (state, data) {
        let keys = Object.keys(data);

        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(data[keys[i]])) {
                state.appointmentList.filters[keys[i]].splice(0, state.appointmentList.filters[keys[i]].length,
                    ...data[keys[i]]);
            } else {
                if (keys[i] === 'filter') {
                    let filter = data[keys[i]];
                    if ((filter instanceof String || typeof filter == 'string') && filter.length > 200) {
                        filter = filter.substring(0, 200);
                    }
                    state.appointmentList.filters[keys[i]] = filter;
                } else {
                    state.appointmentList.filters[keys[i]] = data[keys[i]];
                }
            }
        }
    },

    /**
     * Toggles service appointment list filters sidebar.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_FILTER_SIDEBAR (state, data) {
        state.appointmentList.filtersOpen = data;
    },

    /**
     * Removes single service appointment list filter.
     *
     * @param state State object
     * @param data Data object
     */
    REMOVE_FILTER (state, data) {
        for (let i = 0; i < state.appointmentList.filters[data.field].length; i++) {
            if (state.appointmentList.filters[data.field][i].id === data.id) {
                state.appointmentList.filters[data.field].splice(i, 1);
            }
        }
    },

    /**
     * Toggles action with reason block.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_ACTION_WITH_REASON (state, data) {
        if (data.open) {
            state.editAppointmentModal.actionWithReason.action = data.action;
            state.editAppointmentModal.actionWithReason.isOpen = data.open;

            return;
        }

        state.editAppointmentModal.actionWithReason.isOpen = data.open;
        state.editAppointmentModal.actionWithReason.action = '';
        state.editAppointmentModal.actionWithReason.reason = '';
        state.editAppointmentModal.actionWithReason.errors = {};
    },

    /**
     * Sets action with reason, reason value.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_REASON (state, data) {
        state.editAppointmentModal.actionWithReason.reason = data;
    },

    /**
     * Sets action with reason errors.
     *
     * @param state State object
     * @param data Data object
     */
    SET_ACTION_ERRORS (state, data) {
        state.editAppointmentModal.actionWithReason.errors = data;
    },

    /**
     * Sets base route for service appointment modal
     *
     * @param state State object
     * @param name base route name
     */
    SET_BASE_ROUTE (state, name) {
        state.editAppointmentModal.baseRoute = name;
    },

    /**
     * Toggles service appointment find time modal.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_FIND_TIME_MODAL (state, data) {
        state.editAppointmentModal.isFindTimeOpen = data;
    },

    /**
     * Toggles service appointment deletion modal.
     *
     * @param state State object
     * @param data Data object
     */
    TOGGLE_APPOINTMENT_DELETE_MODAL (state, data) {
        state.deleteAppointmentModal.isOpen = data.isOpen;
        state.deleteAppointmentModal.deletingId = data.id;
    },
    /**
     * Related service appointment data
     *
     * @param state
     * @param data
     */
    SET_RELATED_SERVICE_APPOINTMENTS (state, data) {
        state.relatedServiceAppointments = data;
    },
    ADD_APPOINTMENT_CONTACT(state, contact) {
        state.editAppointmentModal.data.contacts.push(contact);
    },
    REMOVE_APPOINTMENT_CONTACT(state, key) {
        state.editAppointmentModal.data.contacts.splice(key, 1);
    },
};
